import { render } from "./professionals-sales-form.vue?vue&type=template&id=3d967d28&scoped=true"
import script from "./professionals-sales-form.vue?vue&type=script&lang=js"
export * from "./professionals-sales-form.vue?vue&type=script&lang=js"

import "./professionals-sales-form.vue?vue&type=style&index=0&id=3d967d28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d967d28"]])

export default __exports__